import { http } from '../../config/axios'

export default function getAcoesRegraCredito(): Promise<any[]> {
  return http
    .get('api/motorcredito/acoes')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getAcoesRegraCredito', error)
      throw Error(error.response.data)
    })
}
